export default "__VITE_ASSET__CAkV13g5__"